import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from 'components/Button';
import { useMediaQuery } from '@mui/material';

const Hero = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Box
      width={'100%'}
      maxHeight={'450px'}
      height={{ xs: 'auto', sm: '450px' }}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      sx={{
        padding: { xs: '64px 16px', md: '64px' },
        background: theme.palette.lightGrey[200],
      }}
    >
      <Box
        display={'flex'}
        flexDirection={'column'}
        maxWidth={'768px'}
        width={'100%'}
        alignItems={'center'}
        marginBottom={'40px'}
      >
        <Typography
          variant={isMd ? 'h4' : 'h5'}
          color={theme.palette.darkGrey[700]}
          sx={{
            fontWeight: 700,
            width: '100%',
            letterSpacing: '-0.72px',
            marginBottom: { xs: '12px', sm: '20px' },
            textAlign: { xs: 'left', sm: 'center' },
          }}
        >
          {t('supportTitle')}
        </Typography>
        <Typography
          variant={isMd ? 'body2' : 'body1'}
          color={theme.palette.darkGrey[600]}
          sx={{
            fontWeight: 400,
            maxWidth: '638px',
            width: '100%',
            textAlign: { xs: 'left', sm: 'center' },
          }}
        >
          {t('supportSubtitle')}
        </Typography>
      </Box>
      <Box display={'flex'} justifyContent={'center'} width={'100%'}>
        <Button
          buttontype={'orange'}
          onClick={() => window.open('https://deklaravimas.vmi.lt/')}
          width={{ xs: '100%', sm: 'auto' }}
        >
          {t('dedicate')}
        </Button>
      </Box>
    </Box>
  );
};

export default Hero;
